import React, { useContext, useMemo } from 'react';
import _ from 'lodash';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import PropTypes from 'prop-types';
import { TranslatorContext, IntlContext, FormattedMessage } from '@jutro/locale';
import { DateUtil } from 'gw-portals-util-js';
import metadata from './RiskManagementNotifications.metadata.json5';
import styles from '../../RiskManagement.module.scss';
import messages from '../../RiskManagement.messages';

function RiskManagementNotifications({ notifications }) {
    const translator = useContext(TranslatorContext);
    const intl = useContext(IntlContext);
    const generateOverrides = useMemo(() => {
        const overrides = notifications.map((item, index) => {
            const expiryDate = intl.formatDate(new Date(item.endDate), { year: 'numeric', month: 'long', day: 'numeric' });
            const dateStatus = DateUtil.compareIgnoreTime(item.endDate,
                DateUtil.currentDate().toString());
            let notificationMessage = null;
            if (dateStatus === 1) {
                notificationMessage = messages.rmNotifications;
            }
            const getRegisterNowUrl = () => {
                return (
                    <FormattedMessage
                        {...notificationMessage}
                        values={{
                            date: expiryDate,
                            policyNumber: item.policyNumber,
                            productName: item.productName,
                            link:
    <a
        href="https://www.tdicinsurance.com/Seminars"
        rel="noopener noreferrer"
        target="_blank"
        className={styles.noUnderline}
    >
        Register now
    </a>
                        }}
                    />
                );
            };
            return {
                [`rmNotification${index}`]: {
                    message: getRegisterNowUrl(),
                    visible: !_.isNil(notificationMessage)
                }
            };
        });
        return Object.assign({}, ...overrides);
    }, [intl, notifications, translator]);
    const overrideProps = {
        rmNotificationContainer: {
            data: notifications
        },
        ...generateOverrides
    };

    const resolvers = {
        resolveClassNameMap: styles
    };

    return renderContentFromMetadata(metadata.pageContent, overrideProps, resolvers);
}

RiskManagementNotifications.propTypes = {
    notifications: PropTypes.shape([])
};
RiskManagementNotifications.defaultProps = {
    notifications: []
};

export default RiskManagementNotifications;
